import { forwardRef, type SVGProps } from 'react';

export const DoneIconLight = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function DoneIconLight(props, ref) {
    return (
      <svg
        ref={ref}
        fill="none"
        viewBox="0 0 26 26"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle
          cx="13"
          cy="13"
          fill="white"
          r="12.75"
          stroke="#173C88"
          strokeWidth="0.5"
        />
        <path
          d="M10.8333 19.2396L5 13.4063L6.11979 12.2865L10.8333 17L20.8333 7L21.9531 8.11979L10.8333 19.2396Z"
          fill="#173C88"
        />
      </svg>
    );
  },
);
